<template>
  <div v-title="$route.meta.title">
    <div class="page-heading"
         style="position:relative;">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户标签管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">搜索</template>
      <el-form :model="search"
               label-width="150px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()"
               ref="searchForm">
        <div class="re-el-form__flex">
          <el-form-item label="用户ID"
                        prop="userid">
            <el-input class="width-max"
                      placeholder="请输入用户ID进行搜索"
                      v-model="search.userid">
            </el-input>
        </el-form-item>

          <el-form-item label="任务类型"
                        prop="task_types">
            <el-select class="width-max"
                       v-model="search.task_types"
                       clearable
                       multiple
                       @change="changeTaskTypes()"
                       placeholder="未选择时 任务做单准确率 选项将被禁用">
              <el-option v-for="item in getSortedTaskTypes"
                         v-if="item.value + '' !== '21'"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value + ''">
                <template v-if="item.deprecated">
                  <span style="float: left;color: #9ba0a5;">{{ item.label }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.desc }}
                  </span>
                </template>
                <template v-else>
                  <span style="float: left;">{{ item.label }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.desc }}</span>
                </template>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号"
                        prop="cellphone">
            <el-input class="width-max"
                      placeholder="请输入手机号进行搜索"
                      v-model="search.cellphone">
            </el-input>
          </el-form-item>

          <el-form-item label="标签"
                        prop="tags">
            <remote-select class="width-max"
                           clearable
                           multiple
                           id-key="id"
                           label-key="tagname"
                           value-key="id"
                           placeholder="请输入用户标签关键字搜索(支持多选)"
                           v-model="search.tags"
                           :queryParams="{is_group: 0}"
                           :query-request="getUserTagTable"
                           :find-request="getUserTagDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="标签组"
                        prop="tag_group">
            <remote-select class="width-max"
                           clearable
                           multiple
                           id-key="id"
                           label-key="tagname"
                           value-key="id"
                           placeholder="请输入标签组关键字搜索(支持多选)"
                           v-model="search.tag_group"
                           :queryParams="{is_group: 1}"
                           :query-request="getUserTagTable"
                           :find-request="getUserTagDetail">
            </remote-select>
          </el-form-item>

          <el-form-item label="当前心跳位置"
                        prop="current_location">
            <CascaderDistrict class="width-max"
                              clearable
                              v-model="search.current_location"
                              :changeOnSelect="false"/>
          </el-form-item>
          <el-form-item label="身份证覆盖位置"
                        prop="id_card_location">
            <CascaderDistrict class="width-max"
                              clearable
                              v-model="search.id_card_location"
                              :changeOnSelect="false"/>
          </el-form-item>

          <el-form-item label="历史覆盖类型"
                        prop="history_order_covered_type">
            <el-select class="width-max"
                       v-model="search.history_order_covered_type"
                       @change="changeCoveredType()"
                       clearable
                       placeholder="未选择时 历史覆盖位置 选项将被禁用">
              <el-option key="1"
                         label="签到未提交"
                         value="1"/>
              <el-option key="2"
                         label="提交未通过"
                         value="2"/>
              <el-option key="3"
                         label="审核通过"
                         value="3"/>
            </el-select>
          </el-form-item>
          <el-form-item label="任务做单准确率(%)"
                        prop="task_type_approved_rate">
            <el-input style="width: 45%;"
                      placeholder="%"
                      clearable
                      :disabled="search.task_types.length !== 1"
                      v-model="search.task_type_approved_rate[0]"/>
            <span style="width: 7%;display: inline-block;text-align: center;"> - </span>
            <el-input style="width: 45%;"
                      placeholder="%"
                      clearable
                      :disabled="search.task_types.length !== 1"
                      v-model="search.task_type_approved_rate[1]"/>
          </el-form-item>

          <el-form-item label="历史覆盖位置"
                        prop="history_order_covered_location">
            <CascaderDistrict class="width-max"
                              :disabled="!search.history_order_covered_type"
                              clearable
                              v-model="search.history_order_covered_location"
                              :changeOnSelect="false"/>
          </el-form-item>
          <el-form-item label="综合做单准确率(%)"
                        prop="all_approved_rate">
            <el-input style="width: 45%;"
                      placeholder="%"
                      clearable
                      v-model="search.all_approved_rate[0]"/>
            <span style="width: 7%;display: inline-block;text-align: center;"> - </span>
            <el-input style="width: 45%;"
                      placeholder="%"
                      clearable
                      v-model="search.all_approved_rate[1]"/>
          </el-form-item>

          <el-form-item label="做单质量"
                        prop="order_rank_avg">
            <el-input style="width: 45%;"
                      placeholder="最低分"
                      clearable
                      v-model="search.order_rank_avg[0]"/>
            <span style="width: 7%;display: inline-block;text-align: center;"> - </span>
            <el-input style="width: 45%;"
                      placeholder="最高分"
                      clearable
                      v-model="search.order_rank_avg[1]"/>
          </el-form-item>
          <el-form-item label="恶意弃单率(%)"
                        prop="order_canceled_avg">
            <el-input style="width: 45%;"
                      placeholder="%"
                      clearable
                      v-model="search.order_canceled_avg[0]"/>
            <span style="width: 7%;display: inline-block;text-align: center;"> - </span>
            <el-input style="width: 45%;"
                      placeholder="%"
                      clearable
                      v-model="search.order_canceled_avg[1]"/>
          </el-form-item>

          <el-form-item label="恶意弃单次数"
                        prop="order_canceled_cnt">
            <el-input style="width: 45%;"
                      placeholder="次"
                      clearable
                      v-model="search.order_canceled_cnt[0]"/>
            <span style="width: 7%;display: inline-block;text-align: center;"> - </span>
            <el-input style="width: 45%;"
                      placeholder="次"
                      clearable
                      v-model="search.order_canceled_cnt[1]"/>
          </el-form-item>
          <el-form-item label="做单数量"
                        prop="all_approved_cnt">
            <el-input style="width: 45%;"
                      placeholder="个"
                      clearable
                      v-model="search.all_approved_cnt[0]"/>
            <span style="width: 7%;display: inline-block;text-align: center;"> - </span>
            <el-input style="width: 45%;"
                      placeholder="个"
                      clearable
                      v-model="search.all_approved_cnt[1]"/>
          </el-form-item>

          <el-form-item label="参与客户数量"
                        prop="customer_count">
            <el-input style="width: 45%;"
                      placeholder="个"
                      clearable
                      v-model="search.customer_count[0]"/>
            <span style="width: 7%;display: inline-block;text-align: center;"> - </span>
            <el-input style="width: 45%;"
                      placeholder="个"
                      clearable
                      v-model="search.customer_count[1]"/>
          </el-form-item>
          <el-form-item label="证据类型"
                        prop="evidence_types">
            <el-select class="width-max"
                       v-model="search.evidence_types"
                       clearable
                       multiple
                       placeholder="请选择证据类型">
              <el-option v-for="(label, value) in userOrderStat.evidenceTypeMap"
                         :key="value + ''"
                         :label="label"
                         :value="value + ''">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="注册时间"
                        prop="evidence_types">
            <el-date-picker class="width-max"
                            v-model="search.registertime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :default-time="['00:00:00', '23:59:59']"
                            align="center"
                            clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="用户类型"
                        prop="usertype">
            <el-select v-model="search.usertype"
                       placeholder="请选择"
                       class="width-max"
                       multiple
                       clearable>
              <el-option v-for="item in userOptions.type"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value + ''">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="剔除用户类型"
                        prop="not_usertype">
            <el-select v-model="search.not_usertype"
                       placeholder="请选择"
                       class="width-max"
                       multiple
                       clearable>
              <el-option v-for="item in userOptions.type"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value + ''">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="剔除标签用户"
                        prop="not_tags">
            <remote-select class="width-max"
                           clearable
                           multiple
                           id-key="id"
                           label-key="tagname"
                           value-key="id"
                           placeholder="请输入用户标签关键字搜索(支持多选)"
                           v-model="search.not_tags"
                           :query-request="getUserTagTable"
                           :find-request="getUserTagDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="剔除标签组"
                        prop="not_tag_group">
            <remote-select class="width-max"
                           clearable
                           multiple
                           id-key="id"
                           label-key="tagname"
                           value-key="id"
                           placeholder="请输入标签组关键字搜索(支持多选)"
                           v-model="search.not_tag_group"
                           :queryParams="{is_group: 1}"
                           :query-request="getUserTagTable"
                           :find-request="getUserTagDetail">
            </remote-select>
          </el-form-item>

          <el-form-item label="累计做单金额"
                        prop="cumulative_bounty">
            <el-input style="width: 45%;"
                      placeholder="元"
                      clearable
                      v-model="search.cumulative_bounty[0]"/>
            <span style="width: 7%;display: inline-block;text-align: center;"> - </span>
            <el-input style="width: 45%;"
                      placeholder="元"
                      clearable
                      v-model="search.cumulative_bounty[1]"/>
          </el-form-item>

        </div>

        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit"
                     size="medium">搜索
          </el-button>
          <el-button @click="resetForm()"
                     size="medium">重置搜索项
          </el-button>
          <el-button @click="exportBySearch()"
                     type="primary"
                     icon="sj-icon-export"
                     size="medium">导出
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <el-button type="primary"
                   :disabled="multiSelection.length < 1"
                   @click="openAddTagByIds()"
                   size="mini"> 按选中ID添加标签
        </el-button>
        <el-button type="danger"
                   :disabled="multiSelection.length < 1"
                   @click="openDelTagByIds()"
                   size="mini"> 按选中ID删除标签
        </el-button>
        <el-button type="primary"
                   @click="openAddTagBySearch()"
                   size="mini"> 按搜索条件添加标签
        </el-button>
        <el-button type="danger"
                   @click="openDelTagBySearch()"
                   size="mini"> 按搜索条件删除标签
        </el-button>
      </div>

      <el-table :data="table"
                stripe
                highlight-current-row
                border
                @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"/>

        <template v-for="attr of tableFields">
          <el-table-column v-bind="attr"
                           :prop="attr.prop"
                           :key="attr.prop">
            <template slot-scope="scope">
              <el-tooltip class="item"
                          effect="dark"
                          :content="scope.row[attr.prop] + ''"
                          placement="top">
                <div class="ellipsis-cell">{{ scope.row[attr.prop] }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
        </template>

        <el-table-column fixed="right"
                         label="操作"
                         width="120">
          <template slot-scope="scope">
            <router-link :to="`/user-order-stat/detail/${scope.row.userid}`">
              <el-button size="mini"
                         type="primary">查看
              </el-button>
            </router-link>
          </template>
        </el-table-column>

      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

    <el-dialog :title="tagDialogTitle"
               :visible.sync="tagDialogVisible"
               width="50%">
      <div>当前选中了 <span style="color: red;">{{selectedCnt}}</span> 个用户</div><br>

      <el-form ref="tagForm"
               :model="tagForm"
               label-width="100px"
               class="demo-ruleForm">
        <el-row class="text item">
          <el-form-item prop="tags"
                        required
                        label="标签:">
            <remote-select class="width-max"
                           clearable
                           multiple
                           id-key="id"
                           label-key="tagname"
                           value-key="id"
                           placeholder="请输入用户标签关键字搜索(支持多选)"
                           v-model="tagForm.tags"
                           :queryParams="{is_group: 0}"
                           :query-request="getUserTagTable"
                           :find-request="getUserTagDetail">
            </remote-select>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="closeTagDialog()">取 消</el-button>
        <el-button type="primary"
                   @click="onSubmitTagForm()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import table from '@core/mixins/table'
import CascaderDistrict from '@/views/area/components/CascaderDistrict'
import userOrderStatMixins from '../userOrderStat.mixins'

export default {
  mixins: [table, userOrderStatMixins],
  data () {
    return {
      search: {
        userid: null,
        task_types: [],
        cellphone: null,
        tags: [],
        tag_group: [],
        not_tag_group: [],
        not_tags: [],
        current_location: [],
        id_card_location: [],
        history_order_covered_location: [],
        customer_ids: [],
        evidence_types: [],
        usertype: [],
        not_usertype: ['90'],
        registertime: null,
        history_order_covered_type: null,
        task_type_approved_rate: [null, null],
        all_approved_rate: [null, null],
        order_rank_avg: [null, null],
        order_canceled_avg: [null, null],
        order_canceled_cnt: [null, null],
        all_approved_cnt: [null, null],
        customer_count: [null, null],
        cumulative_bounty: [null, null],
      },
      searchFieldType: {
        task_types: Array
      },
      tagForm: {
        action: null,
        tags: [],
        search_params: {},
      },
      table: [],
      multiSelection: [],
      tagDialogTitle: '',
      selectedCnt: 0,
      tagDialogVisible: false,
    }
  },
  components: {
    CascaderDistrict,
  },
  computed: {
    ...Vuex.mapState({
      userOptions: state => state.users.options,
      userOrderStat: state => state.userOrderStat,
    }),
    ...Vuex.mapGetters('order', ['getSortedTaskTypes']),
  },
  methods: {
    ...request.map([
      'getUserTagTable', 'getUserTagDetail',
    ]),
    getTableData (params) {
      return request.common('queryUserOderStatApi', this.prepareParams(params)).then(response => {
        response.data.data = response.data.data.map((item) => {
          const usertype = this.userOptions.type.find(it => it.value + '' === item.usertype + '')
          item.usertype = _.get(usertype, 'label', item.usertype)
          item.task_types = item.task_types.join(', ')
          item.tags = item.tags.join(', ')
          item.current_location = item.current_location.join('-')
          item.id_card_location = item.id_card_location.join('-')
          item.all_approved_rate = this.multiplyBy100(_.get(item, 'order_measurement.all.approved_rate', 0), 2, '%')
          item.order_canceled_avg = this.multiplyBy100(_.get(item, 'order_canceled_avg', 0), 2, '%')
          item.all_approved_cnt = _.get(item, 'order_measurement.all.approved_cnt', 0)
          item.evidence_types = item.evidence_types.map(it => this.userOrderStat.evidenceTypeMap[it]).join(', ')
          item.last_active_tp = item.last_active_tp === '1970-01-01 00:00:00' ? '-' : item.last_active_tp
          return item
        })
        return response
      })
    },
    resetForm () {
      this.$refs['searchForm'].resetFields()
    },
    exportBySearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.tableFields.map(item => {
          const {prop, label, ...rest} = item
          return {key: prop, text: label, ...rest}
        }),
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
      })
    },
    handleSelectionChange (val) {
      this.multiSelection = val
    },
    openAddTagByIds () {
      this.tagDialogTitle = '按已选中用户ID来添加标签'
      this.tagDialogVisible = true
      this.tagForm.action = 'add_tag_by_ids'
      this.tagForm.tags = []
      this.tagForm.search_params = {userid: this.multiSelection.map(item => item.userid)}
      this.selectedCnt = this.multiSelection.length
    },
    openDelTagByIds () {
      this.tagDialogTitle = '按已选中用户ID来删除标签'
      this.tagDialogVisible = true
      this.tagForm.action = 'del_tag_by_ids'
      this.tagForm.tags = []
      this.tagForm.search_params = {userid: this.multiSelection.map(item => item.userid)}
      this.selectedCnt = this.multiSelection.length
    },
    openAddTagBySearch () {
      this.tagDialogTitle = '按搜索条件来添加标签'
      this.tagForm.action = 'add_tag_by_search'
      this.tagForm.tags = []
      this.tagForm.search_params = this.prepareParams(this.search)
      this.selectedCnt = this.pagination.total
      this.tagDialogVisible = true
    },
    openDelTagBySearch () {
      this.tagDialogTitle = '按搜索条件来删除标签'
      this.tagForm.action = 'del_tag_by_search'
      this.tagForm.tags = []
      this.tagForm.search_params = this.prepareParams(this.search)
      this.selectedCnt = this.pagination.total
      this.tagDialogVisible = true
    },
    closeTagDialog () {
      this.tagDialogVisible = false
      this.tagForm.action = ''
      this.tagForm.tags = []
      this.tagForm.search_params = {}
    },
    onSubmitTagForm () {
      switch (this.tagForm.action) {
        case 'add_tag_by_ids':
        case 'add_tag_by_search':
          return request.common('userAddTagBySearchApi', _.cloneDeep(this.tagForm)).then(({data}) => {
            this.$message.success('按条件新增用户标签任务创建成功')
            this.closeTagDialog()
          })
        case 'del_tag_by_ids':
        case 'del_tag_by_search':
          return request.common('userDelTagBySearchApi', _.cloneDeep(this.tagForm)).then(({data}) => {
            this.$message.success('按条件删除用户标签任务创建成功')
            this.closeTagDialog()
          })
        default:
          this.$message.error('错误:未知的 tagForm.action')
      }
    },
    // 任务类型数量不为1的时候,不支持搜索任务做单准确率
    changeTaskTypes () {
      if (this.search.task_types.length !== 1) {
        this.search.task_type_approved_rate[0] = null
        this.search.task_type_approved_rate[1] = null
      }
    },
    // 更换了历史覆盖类型,若清空选项,则需要把 history_order_covered_location 置空
    changeCoveredType () {
      if (!this.search.history_order_covered_type) {
        this.search.history_order_covered_location = []
      }
    },
    multiplyBy100 (num, digit = 2, suffix = '') {
      const str = (num * 100).toFixed(digit)
      return Number(str) + suffix
    },
    prepareParams (params) {
      const newParams = _.cloneDeep(params)
      if (!!newParams.history_order_covered_type && _.isArray(newParams.history_order_covered_location) && newParams.history_order_covered_location.length > 0) {
        switch (newParams.history_order_covered_type + '') {
          case '1': // 签到未提交
            newParams.order_covered_nonsubmitted_locations = newParams.history_order_covered_location
            break
          case '2': // 提交未通过
            newParams.order_covered_rejected_locations = newParams.history_order_covered_location
            break
          case '3': // 审核通过
            newParams.order_covered_approved_locations = newParams.history_order_covered_location
            break
        }
        delete newParams['history_order_covered_location']
      }
      return newParams
    }
  }
}
</script>
<style>
.ellipsis-cell {
  display: -webkit-box; /* 将对象作为弹性伸缩盒子模型显示 */
  -webkit-box-orient: vertical; /* 设置伸缩盒子的子元素排列方式为垂直排列 */
  -webkit-line-clamp: 2; /* 限制显示的行数为2行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
  width: 100%; /* 确保占满单元格宽度 */
  line-height: 1.5; /* 可根据需要调整行高 */
}
/* 可选：调整tooltip样式 */
.el-tooltip__popper {
  max-width: 80%; /* 限制tooltip最大宽度，防止内容过长 */
}
</style>



// WEBPACK FOOTER //
// src/views/user-order-stat/pages/UserOrderStatTable.vue